/* Get Joy — Fresh Meals PDP (v12). Buy box, gallery, sizing sheet, plan state.
   Portion math mirrors the live Fresh buy box (gj-fresh-buybox): MER on the tier's representative weight,
   kcal/g from the variant metafield, packs = ceil(daily packs × days), clamped to 14 … 42 (half-lb) / 34 (1-lb).
   Cart quantity = packs. First box = packs × (plan price − the checkout function's 44.46%), same as FDR/Treats,
   so the page matches the cart to the cent. */
(function () {
  var root = document.querySelector('[data-gjf-root]');
  var cfgEl = document.querySelector('[data-gjf-config]');
  if (!root || !cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = function (c) { return '$' + (c / 100).toFixed(2); };
  var setText = function (s, t) { $$(s).forEach(function (el) { if (el.textContent !== t) el.textContent = t; }); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var firstOf = function (renew) { return renew - Math.floor(renew * CFG.trialDiscount / 10000); };
  var withW = function (u, w) { return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : ''; };
  var GPL = 453.592;

  var recipeKeys = Object.keys(CFG.recipes || {});
  var offered = $$('[data-gjf-freq]').map(function (b) { return +b.getAttribute('data-gjf-freq'); }).sort(function (a, b) { return a - b; });
  var concerns = $$('[data-gjf-concern]');

  var slides = null, thumbs = null, gal = 0;
  var S = { recipe: recipeKeys[0] || 'turkey', weight: 30, mode: 'meal', stage: 'adult', freq: null, buyType: 'sub', addons: {}, plan: null, sticky: false, concern: -1, benef: 0, benefUser: false, sheet: { w: 30, stage: 'adult', mode: 'meal' } };

  /* ---------- plan state (quiz) ---------- */
  try {
    var raw = localStorage.getItem('gj_quiz_state_v1');
    if (raw) { var qs = JSON.parse(raw); if (qs && qs.a && qs.a.name && (qs.screen === 'plan' || qs.screen === 'build')) S.plan = qs.a; }
  } catch (e) {}
  if (S.plan) {
    var a = S.plan;
    a.name = String(a.name).replace(/[<>&"']/g, '').slice(0, 24);
    var w = parseFloat(a.weight); if (w > 0) S.weight = Math.max(5, Math.min(120, Math.round(w)));
    if (a.protein && CFG.recipes[a.protein]) S.recipe = a.protein;
    if (a.mode === 'topper' || (!a.mode && a.prep === 'mixed')) S.mode = 'topper';
    var ag = parseFloat(a.age); if (!isNaN(ag)) S.stage = ag < 1 ? 'puppy' : ag >= 8 ? 'senior' : 'adult';
    var g0 = (a.goals || [])[0];
    if (g0) concerns.forEach(function (c, i) { if (c.getAttribute('data-goal') === g0) S.concern = i; });
  }

  /* ---------- portion + cadence (live rules) ---------- */
  function tierFor(lb) {
    for (var i = 0; i < CFG.tiers.length; i++) if (lb < CFG.tiers[i].max) return CFG.tiers[i];
    return CFG.tiers[CFG.tiers.length - 1];
  }
  function variantFor(recipe, tier) { var r = CFG.recipes[recipe]; return r && r.v ? r.v[tier.tok] : null; }
  function calc(lb, recipe, mode, freqSel) {
    var t = tierFor(lb), v = variantFor(recipe, t) || {};
    var packLbs = /half/i.test(t.tok) ? 0.5 : 1;
    var kcal = v.kcal || 1.474, M = CFG.mer;
    var mer = 70 * Math.pow((t.w || 17) / 2.2, 0.75) * M.a * M.n * M.act * M.mod;
    var dg = mer / kcal;
    var dp = (dg / GPL) / packLbs * (mode === 'topper' ? 0.5 : 1);
    var maxP = packLbs >= 1 ? CFG.pmaxOne : CFG.pmaxHalf, minP = CFG.pmin;
    var avail = offered.length ? offered : [1, 2, 3, 5];
    var packs = function (wk) { return Math.ceil(dp * wk * 7); };
    var best = avail[0], p2 = packs(2);
    if (avail.indexOf(2) > -1 && p2 >= minP && p2 <= maxP) best = 2;
    else if (minP > p2) {
      var target = minP / (dp * 7);
      best = avail.slice().sort(function (a, b) { return (Math.abs(a - target) - Math.abs(b - target)) || (a - b); })[0];
    } else {
      var c2 = avail.filter(function (wk) { return wk < 2 && packs(wk) <= maxP; });
      best = c2.length ? c2[c2.length - 1] : avail[0];
    }
    var clamp = function (n) { return Math.max(minP, Math.min(maxP, n)); };
    var valid = avail.filter(function (wk) { var p = packs(wk); return (p >= minP && p <= maxP) || wk === best; });
    var wk = freqSel && valid.indexOf(freqSel) > -1 ? freqSel : best;
    return { tier: t, v: v, packLbs: packLbs, dg: dg, dp: dp, wk: wk, best: best, packs: clamp(packs(wk)), valid: valid, packsFor: function (x) { return clamp(packs(x)); } };
  }

  function prices() {
    var P = calc(S.weight, S.recipe, S.mode, S.freq), v = P.v;
    var pl = v.plans ? v.plans[String(P.wk)] : null;
    var unit = v.price || 0, renewU = pl ? pl.price : unit;
    var full = unit * P.packs, renew = renewU * P.packs, first = firstOf(renewU) * P.packs;
    /* One-month trial (same rules as the FDR buy box): a month of food (28 days, within the box limits) whatever cadence
       is picked, one-time, TRIAL25 taken per unit and floored the way Shopify allocates it, so page = cart = checkout. */
    // Oct 20 (Zach): a true 28 days for every dog — the trial is not held to the one-box pack cap (ops ships it as needed).
    var otpPacks = Math.max(CFG.pmin, Math.ceil(P.dp * 28 - 1e-9)), otpDays = 28;
    var otpFull = unit * otpPacks;
    var otp = CFG.trial ? otpPacks * (unit - Math.floor(unit * CFG.trialPct / 100)) : otpFull;
    var addonTotal = 0;
    $$('[data-gjf-addon]').forEach(function (b) {
      if (!S.addons[b.getAttribute('data-gjf-addon')]) return;
      var pe = b.parentNode.querySelector('.gjc-ad-price');
      var f = +pe.getAttribute('data-full'), r = +pe.getAttribute('data-renew');
      addonTotal += S.buyType === 'sub' ? firstOf(r) : f;
    });
    return { P: P, v: v, plan: pl, full: full, renew: renew, first: first, otp: otp, otpFull: otpFull, otpPacks: otpPacks, otpDays: otpDays, addonTotal: addonTotal, total: (S.buyType === 'sub' ? first : otp) + addonTotal };
  }

  var sizeLabel = function (P) { return P.packLbs >= 1 ? '1-lb' : '½-lb'; };
  var wkWord = function (wk) { return wk === 1 ? 'week' : wk + ' weeks'; };
  var name = function () { return S.plan ? S.plan.name : ''; };

  function render() {
    var d = prices(), P = d.P, R = CFG.recipes[S.recipe] || {}, wk = P.wk;
    root.style.setProperty('--gjc-tone', R.color || '#C76BFC');

    $$('[data-gjf-recipe]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjf-recipe') === S.recipe ? 'true' : 'false'); });
    $$('[data-gjf-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjf-mode') === S.mode ? 'true' : 'false'); });
    $$('[data-gjf-buytype]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjf-buytype') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjf-card]').forEach(function (c) { c.setAttribute('data-on', c.getAttribute('data-gjf-card') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjf-for]').forEach(function (el) { el.hidden = el.getAttribute('data-gjf-for') !== S.recipe; });
    var ws = $('[data-gjf=weight]'); if (ws && +ws.value !== S.weight) ws.value = S.weight;
    setText('[data-gjf=weight-val]', S.weight + ' lb');

    // cadence chips: only cadences whose box fits the pack limits (plus the recommended one)
    $$('[data-gjf-freq]').forEach(function (b) {
      var x = +b.getAttribute('data-gjf-freq');
      b.hidden = P.valid.indexOf(x) < 0;
      b.setAttribute('aria-checked', x === wk ? 'true' : 'false');
      var sm = b.querySelector('[data-gjf-freqpacks]'); if (sm) sm.textContent = ' · ' + (x * 7) + ' days of meals';
    });

    // images follow the recipe (R54: gallery = admin media filtered by #flavor_ tag)
    if (slides && galKey !== S.recipe) { galKey = S.recipe; galFlavor(S.recipe); }
    ['bowl', 'pack', 'pkg', 'ing'].forEach(function (k) {
      if (!R[k]) return;
      var im = $('[data-gjf-img=' + k + ']'); if (im && im.getAttribute('data-k') !== S.recipe) { im.src = withW(R[k], 900); im.setAttribute('data-k', S.recipe); }
      var th = $('[data-gjf-thumbimg=' + k + ']'); if (th) th.src = withW(R[k], 120);
    });
    var ci = $('[data-gjf=close-img]'); if (ci && R.bowl) ci.style.backgroundImage = "url('" + withW(R.bowl, 400) + "')";
    var si = $('[data-gjf=sticky-img]'); if (si && R.bowl) si.style.backgroundImage = "url('" + withW(R.bowl, 120) + "')";

    // plan summary
    var days = wk * 7, isOtp = S.buyType === 'otp';
    // Oct 14 (team feedback): lead with what the box covers in days, not the pack math
    setText('[data-gjf=spec-packs]', (isOtp ? d.otpDays : days) + ' days');
    setText('[data-gjf=spec-packs-k]', 'of ' + (S.mode === 'topper' ? 'toppers' : 'meals') + (isOtp ? ' in one order · one-time trial' : ' per box · ships every ' + wkWord(wk)));
    setText('[data-gjf=spec-day]', fmt(Math.round(isOtp ? d.otp / d.otpDays : d.renew / days)));
    setText('[data-gjf=spec-day-k]', isOtp ? 'a day on the trial' : 'a day after your first box');
    setText('[data-gjf=cover-text]', (isOtp ? d.otpPacks : P.packs) + ' ' + sizeLabel(P) + ' packs ' + (isOtp ? 'in the order' : 'per box') + ', portioned to your dog' + (S.mode === 'topper' ? ' as a topper' : '') + '.');
    var note = $('[data-gjf=plan-note]');
    if (note) {
      var n = S.stage === 'puppy' ? 'Based on their weight today — growing pups eat more, so re-size every couple of weeks.' : S.stage === 'senior' ? 'Seniors often need a touch less — your vet can fine-tune.' : '';
      note.hidden = !n; note.textContent = n;
    }

    // delivery cards
    setText('[data-gjf=freq-val]', wkWord(wk));
    var rec = $('[data-gjf=freq-rec]'); if (rec) rec.hidden = wk !== P.best;
    setText('[data-gjf=sub-first]', fmt(d.first));
    setText('[data-gjf=sub-was]', fmt(d.full));
    setText('[data-gjf=sub-terms]', days + ' days of meals every ' + wkWord(wk) + ' · then ' + fmt(d.renew) + ' a box (10% off) · skip, pause or cancel anytime');
    setText('[data-gjf=otp-price]', fmt(d.otp));
    var ow = $('[data-gjf=otp-was]'); if (ow) { ow.hidden = !CFG.trial; ow.textContent = fmt(d.otpFull); }
    var ot = $('[data-gjf=otp-terms]'); if (ot) setText('[data-gjf=otp-terms]', d.otpDays + ' days of ' + (S.mode === 'topper' ? 'toppers' : 'meals') + ' · ' + (ot.getAttribute('data-tail') || ''));

    var avail = d.v && d.v.available !== false;
    var label = !avail ? 'Sold out' : (S.buyType === 'sub' ? 'Start their plan — ' : 'Add to cart — ') + fmt(d.total);
    setText('[data-gjf=cta-label]', label);
    setText('[data-gjf=close-cta-label]', label);
    var cta = $('[data-gjf=cta]'); if (cta) cta.disabled = !avail;

    setText('[data-gjf=sticky-sub]', '· ' + (isOtp ? d.otpDays : days) + ' days of meals · ' + (R.name || ''));
    setText('[data-gjf=sticky-price]', fmt(S.buyType === 'sub' ? d.first : d.otp));
    var was = $('[data-gjf=sticky-was]'); if (was) { was.hidden = !(S.buyType === 'sub' || CFG.trial); was.textContent = fmt(isOtp ? d.otpFull : d.full); }
    setText('[data-gjf=sticky-per]', '· ' + fmt(Math.round(isOtp ? d.otp / d.otpDays : d.renew / days)) + '/day');

    // know tiles + pack contents + feeding rows
    var g = P.packLbs * GPL, kPack = String(Math.round((d.v.kcal || 1.474) * g));
    setText('[data-gjf=kcal-pack]', kPack);
    setText('[data-gjf=kcal-pack-k]', 'kcal per ' + sizeLabel(P) + ' pack');
    var gaBox = $$('.gjf-ga [data-gjf-for="' + S.recipe + '"] .gjf-ga-r');
    var tiles = $$('[data-gjf=know-tiles] .gjc-tile');
    gaBox.slice(0, 2).forEach(function (r, i) {
      var t = tiles[i]; if (!t) return;
      var sp = r.querySelectorAll('span,strong');
      t.querySelector('strong').textContent = sp[1].textContent;
      t.querySelector('span').textContent = sp[0].textContent.toLowerCase();
    });
    var rn = (R.name || '').toLowerCase();
    setText('[data-gjf=know-lede]', 'USDA-sourced ' + rn + ' and ' + rn + ' liver, whole foods and ' + (S.recipe === 'lamb' ? 'quinoa, a gentle whole seed' : 'a gentle whole grain') + '. Each one gently cooked on its own, then combined.');
    var pi = $('[data-gjf-img2=pack]'); if (pi && R.pack && pi.getAttribute('data-k') !== S.recipe) { pi.src = withW(R.pack, 300); pi.setAttribute('data-k', S.recipe); }
    setText('[data-gjf=pouch-h]', "What's in a " + sizeLabel(P) + ' pack');
    setText('[data-gjf=pouch-kcal]', kPack);
    setText('[data-gjf=pouch-tier]', P.tier.label.replace(/ lbs?$/, ' lb'));
    setText('[data-gjf=pouch-line]', R.pouch || '');
    var fr = $('[data-gjf=feed-rows]');
    if (fr) {
      fr.innerHTML = CFG.tiers.map(function (t) {
        var cv = variantFor(S.recipe, t) || {};
        var M = CFG.mer, mer = 70 * Math.pow((t.w || 17) / 2.2, 0.75) * M.a * M.n * M.act * M.mod;
        var gd = Math.round(mer / (cv.kcal || 1.474));
        var on = t === P.tier;
        return '<div class="gjc-row' + (on ? ' gjf-on' : '') + '"><span>' + esc(t.label) + '</span><strong>~' + gd + ' g a day · ' + (/half/i.test(t.tok) ? '½-lb' : '1-lb') + ' packs</strong></div>';
      }).join('');
    }

    // concerns
    concerns.forEach(function (c, i) { c.setAttribute('aria-pressed', i === S.concern ? 'true' : 'false'); });
    var panel = $('[data-gjf=concern-panel]');
    if (panel) {
      var cc = concerns[S.concern];
      panel.hidden = !cc;
      if (cc) { setText('[data-gjf=concern-title]', cc.getAttribute('data-title')); setText('[data-gjf=concern-body]', cc.getAttribute('data-body')); }
    }

    // add-ons
    $$('.gjc-ad-price').forEach(function (pe) {
      var f = +pe.getAttribute('data-full'), r = +pe.getAttribute('data-renew');
      pe.textContent = S.buyType === 'sub' ? fmt(firstOf(r)) + ' first order' : fmt(f);
    });
    $$('[data-gjf-addon]').forEach(function (b) {
      var on = !!S.addons[b.getAttribute('data-gjf-addon')];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? '✓ In your order' : 'Add to order';
    });
    var strip = $('[data-gjf=addon-strip]');
    if (strip) {
      var rows = $$('[data-gjf-addon]').filter(function (b) { return S.addons[b.getAttribute('data-gjf-addon')]; });
      strip.hidden = !rows.length;
      strip.innerHTML = rows.length ? '<div class="gjc-eyebrow">Also in your first box</div>' + rows.map(function (b) {
        var pe = b.parentNode.querySelector('.gjc-ad-price');
        return '<div class="gjc-strip-r"><span>' + esc(b.getAttribute('data-name')) + '</span><strong>' + esc(pe.textContent) + '</strong><button type="button" data-gjf-unadd="' + b.getAttribute('data-gjf-addon') + '" aria-label="Remove ' + esc(b.getAttribute('data-name')) + '">×</button></div>';
      }).join('') + '<div class="gjc-strip-t"><span>First box total</span><strong>' + fmt(d.total) + '</strong></div>' : '';
    }
    var rt = $('[data-gjf=routine-total]');
    if (rt) { rt.hidden = !d.addonTotal; setText('[data-gjf=routine-total-t]', 'Added to your first box · total ' + fmt(d.total)); }

    // switch line
    setText('[data-gjf=switch-line]', S.mode === 'topper'
      ? (name() ? name() + ' is on the topper plan' : 'On the topper plan') + ': start with a quarter pack on their current food and build up over about 10 days.'
      : (name() ? name() + "'s switch: mix" : 'Mix') + ' it in over about 10 days, a little more Fresh each step.');
    var st = $('[data-gjf=sticky]'); if (st) st.hidden = !S.sticky;
  }

  function renderPlan() {
    var a = S.plan; if (!a) return;
    var bt = $('[data-gjf=buy-title]');
    if (bt) bt.textContent = (bt.getAttribute('data-title-named') || "Build [name]'s bowl").replace(/\[name\]/g, a.name);
    var chip = $('[data-gjf=profile-chip]');
    if (chip) { chip.hidden = false; $('[data-gjf=profile-line]').innerHTML = '<strong>' + esc(a.name) + '</strong>' + (a.weight ? ' · ' + (+a.weight) + ' lb' : '') + ' · ' + S.stage; }
    var help = $('[data-gjf=sheet-open]'), rt = $('[data-gjf=retake]');
    if (help && rt) { help.hidden = true; rt.hidden = false; }
    setText('[data-gjf=sticky-title]', a.name + "'s plan");
    setText('[data-gjf=close-eyebrow]', a.name + "'s plan is ready");
    setText('[data-gjf=next-eyebrow]', 'What happens next for ' + a.name);
    setText('[data-gjf=concerns-head]', 'What ' + a.name + ' needs help with.');
  }

  /* ---------- sizing sheet ---------- */
  function renderSheet() {
    var sh = S.sheet;
    setText('[data-gjf=h-weight-val]', sh.w + ' lb');
    $$('[data-gjf-hstage]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-gjf-hstage') === sh.stage ? 'true' : 'false'); });
    $$('[data-gjf-hmode]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-gjf-hmode') === sh.mode ? 'true' : 'false'); });
    var P = calc(sh.w, S.recipe, sh.mode, null), v = P.v || {};
    var pl = v.plans ? v.plans[String(P.wk)] : null, ru = pl ? pl.price : (v.price || 0);
    var nm = ($('[data-gjf=h-name]') || {}).value; nm = nm ? String(nm).trim() : '';
    var out = $('[data-gjf=h-out]');
    if (out) out.innerHTML = '<div class="gjx-sheet-out-k">' + esc(nm ? nm + "'s plan" : 'Their plan') + '</div><div class="gjx-sheet-out-v">' + (P.wk * 7) + ' days of meals every ' + wkWord(P.wk) + '</div><div class="gjx-sheet-note">' + P.packs + ' ' + sizeLabel(P) + ' packs per box</div><div class="gjx-sheet-note">' +
      (sh.mode === 'topper' ? 'As a topper on their current food' : 'Every meal fresh') + ' · first box ' + fmt(firstOf(ru) * P.packs) + ', then ' + fmt(ru * P.packs) +
      (sh.stage === 'puppy' ? ' · growing pups often need more — re-size as they grow' : sh.stage === 'senior' ? ' · seniors often need a touch less — your vet can fine-tune' : '') + '</div>';
  }
  function openSheet() {
    S.sheet = { w: S.weight, stage: S.stage, mode: S.mode };
    var hw = $('[data-gjf=h-weight]'); if (hw) hw.value = S.weight;
    var sh = $('[data-gjf=sheet]');
    if (sh) {
      sh.hidden = false; document.documentElement.classList.add('gjx-sheet-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { sh.classList.add('is-in'); var f = $('[data-gjf=h-name]'); if (f) try { f.focus({ preventScroll: true }); } catch (e) {} }); });
    }
    renderSheet();
  }
  function closeSheet() {
    var sh = $('[data-gjf=sheet]'); if (!sh) return;
    sh.classList.remove('is-in'); document.documentElement.classList.remove('gjx-sheet-open');
    setTimeout(function () { sh.hidden = true; }, 220);
    var o = $('[data-gjf=sheet-open]'); if (o && !o.hidden) try { o.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- gallery ---------- */
  var galKey = null;
  slides = $$('[data-gjf-slide]'); thumbs = $$('[data-gjf-thumb]'); gal = 0;
  /* R54: slides come from admin media; media tagged for another flavor carry data-off and are skipped */
  function galOn(s) { return !s.hasAttribute('data-off'); }
  function showSlide(i, dir) {
    var n = slides.length; if (!n) return;
    dir = dir || 1; i = ((i % n) + n) % n;
    for (var g = 0; g < n && !galOn(slides[i]); g++) i = (((i + dir) % n) + n) % n;
    gal = i;
    var gw = slides[0].closest('[data-gj-gal]');
    if (gw) { var fv = -1; for (var q = 0; q < n; q++) { if (galOn(slides[q])) { fv = q; break; } } gw.toggleAttribute('data-first', gal === fv); }
    slides.forEach(function (s, k) {
      var on = k === gal; s.hidden = !on;
      var vid = s.querySelector('video');
      if (vid) { if (on) { if (!vid.src && vid.getAttribute('data-src')) vid.src = vid.getAttribute('data-src'); } else { try { vid.pause(); } catch (e) {} } }
    });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === gal ? 'true' : 'false'); });
  }
  function galFlavor(key) {
    key = String(key || '').toLowerCase();
    [slides, thumbs].forEach(function (L) { L.forEach(function (el) {
      var f = el.getAttribute('data-flavor'); if (f === null) return;
      if (f && key && f !== key) el.setAttribute('data-off', ''); else el.removeAttribute('data-off');
    }); });
    showSlide(0);
  }

  function scrollToBuy() { var bb = $('[data-gjf-buybox]'); if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* ---------- benefits timeline ---------- */
  var benefCards = $$('[data-gjf-benefcard]');
  function setBenef(i) {
    if (!benefCards.length) return;
    S.benef = i % benefCards.length;
    $$('[data-gjf-benef]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjf-benef') === S.benef ? 'true' : 'false'); });
    benefCards.forEach(function (c) { c.hidden = +c.getAttribute('data-gjf-benefcard') !== S.benef; });
  }
  if (benefCards.length > 1) setInterval(function () { if (!S.benefUser && !document.hidden) setBenef(S.benef + 1); }, 3500);

  /* ---------- inputs ---------- */
  var fRaf = 0;
  root.addEventListener('input', function (e) {
    var t = e.target;
    // Oct 14: one render per frame while dragging (smooth on mobile)
    if (t.matches('[data-gjf=weight]')) { S.weight = +t.value; S.freq = null; if (!fRaf) fRaf = requestAnimationFrame(function () { fRaf = 0; render(); }); }
    else if (t.matches('[data-gjf=h-weight]')) { S.sheet.w = +t.value; if (!fRaf) fRaf = requestAnimationFrame(function () { fRaf = 0; renderSheet(); }); }
    else if (t.matches('[data-gjf=h-name]')) renderSheet();
  });

  /* ---------- clicks ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, a') : null;
    if (!t || !root.contains(t)) { if (e.target.matches && e.target.matches('[data-gjf=sheet-close]')) closeSheet(); return; }
    if (t.hasAttribute('data-gjf-recipe')) { S.recipe = t.getAttribute('data-gjf-recipe'); S.freq = null; render(); }
    else if (t.hasAttribute('data-gjf-mode')) { S.mode = t.getAttribute('data-gjf-mode'); S.freq = null; render(); }
    else if (t.hasAttribute('data-gjf-buytype')) { S.buyType = t.getAttribute('data-gjf-buytype'); render(); }
    else if (t.matches('[data-gjf=freq-toggle]')) {
      var chips = $('#gjf-freq-chips'), open = chips.hidden;
      chips.hidden = !open; t.setAttribute('aria-expanded', open ? 'true' : 'false'); t.textContent = open ? 'Done' : 'Change';
      if (S.buyType !== 'sub') { S.buyType = 'sub'; render(); }
    }
    else if (t.hasAttribute('data-gjf-freq')) { S.freq = +t.getAttribute('data-gjf-freq'); S.buyType = 'sub'; render(); }
    else if (t.matches('[data-gjf=cta]')) addToCart(t);
    else if (t.hasAttribute('data-gjf-addon')) { var aid = t.getAttribute('data-gjf-addon'); S.addons[aid] = !S.addons[aid]; render(); }
    else if (t.hasAttribute('data-gjf-unadd')) { S.addons[t.getAttribute('data-gjf-unadd')] = false; render(); }
    else if (t.matches('[data-gjf=to-buy]')) scrollToBuy();
    else if (t.matches('[data-gjf=profile-chip]')) { location.href = '/pages/quiz?retake=1'; }
    else if (t.matches('[data-gjf=sheet-open]')) openSheet();
    else if (t.matches('[data-gjf=sheet-close]')) closeSheet();
    else if (t.hasAttribute('data-gjf-hstage')) { S.sheet.stage = t.getAttribute('data-gjf-hstage'); renderSheet(); }
    else if (t.hasAttribute('data-gjf-hmode')) { S.sheet.mode = t.getAttribute('data-gjf-hmode'); renderSheet(); }
    else if (t.matches('[data-gjf=sheet-use]')) {
      S.weight = S.sheet.w; S.stage = S.sheet.stage; S.mode = S.sheet.mode; S.freq = null;
      var nm = ($('[data-gjf=h-name]') || {}).value;
      if (nm && String(nm).trim()) { S.plan = { name: String(nm).trim().replace(/[<>&"']/g, '').slice(0, 24), weight: S.weight }; renderPlan(); }
      closeSheet(); render(); scrollToBuy();
    }
    else if (t.matches('[data-gjf=gal-prev]')) showSlide(gal - 1, -1);
    else if (t.matches('[data-gjf=gal-next]')) showSlide(gal + 1);
    else if (t.hasAttribute('data-gjf-thumb')) showSlide(+t.getAttribute('data-gjf-thumb'));
    else if (t.hasAttribute('data-gjf-concern')) { var ci = +t.getAttribute('data-gjf-concern'); S.concern = S.concern === ci ? -1 : ci; render(); }
    else if (t.hasAttribute('data-gjf-benef')) { S.benefUser = true; setBenef(+t.getAttribute('data-gjf-benef')); }
    else if (t.classList.contains('gjc-rchip')) {
      var tag = t.getAttribute('data-tag');
      $$('.gjc-rchip').forEach(function (c) { c.setAttribute('aria-pressed', c === t ? 'true' : 'false'); });
      $$('.gjc-rev').forEach(function (r) { r.hidden = !!tag && r.getAttribute('data-tag') !== tag; });
    }
    else if (t.hasAttribute('data-gjf-vid')) {
      var pl = $('[data-gjf=vid-player]'), src = t.getAttribute('data-gjf-vid');
      var already = !pl.hidden && pl.getAttribute('data-src') === src;
      $$('[data-gjf-vid]').forEach(function (v) { v.classList.toggle('is-on', v === t && !already); });
      if (already) { pl.hidden = true; pl.innerHTML = ''; pl.removeAttribute('data-src'); return; }
      pl.setAttribute('data-src', src); pl.hidden = false;
      pl.innerHTML = '<div class="gjc-vp-media"><video src="' + esc(src) + '" autoplay playsinline controls></video><button type="button" data-gjf-vclose aria-label="Close video">×</button></div><div class="gjc-vp-cap"><p>' + esc(t.getAttribute('data-quote') || '') + '</p><strong>' + esc(t.getAttribute('data-who') || '') + '</strong></div>';
    }
    else if (t.hasAttribute('data-gjf-vclose')) { var p2 = $('[data-gjf=vid-player]'); p2.hidden = true; p2.innerHTML = ''; p2.removeAttribute('data-src'); $$('[data-gjf-vid]').forEach(function (v) { v.classList.remove('is-on'); }); }
    else if (t.matches('[data-gjf=founder-play]')) {
      var vsrc = t.getAttribute('data-src'); if (!vsrc) return;
      var vv = document.createElement('video'); vv.src = vsrc; vv.controls = true; vv.autoplay = true; vv.playsInline = true; vv.className = 'gjc-vet-video';
      t.replaceWith(vv);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var sh = $('[data-gjf=sheet]'); if (sh && !sh.hidden) closeSheet(); } });

  /* ---------- cart (add, then open the Rebuy drawer in place) ---------- */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
    var trig = document.querySelector('.js-drawer-open-cart');
    if (trig) trig.click(); else window.location.href = '/cart';
  }
  // One meal plan per dog: adding a plan replaces that dog's existing plan line for this product (re-adding from the
  // quiz, the PDP, or after editing used to stack, e.g. 9 + 9 bags). Different dogs (different _dog_name) stay separate.
  function replacePlan(handle, dog) {
    dog = String(dog || '').trim();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var up = {};
      (c.items || []).forEach(function (i) { if (i.handle === handle && i.final_line_price > 0 && String((i.properties || {})._dog_name || '').trim() === dog) up[i.key] = 0; });
      if (!Object.keys(up).length) return null;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up }) });
    }).catch(function () { return null; });
  }
  function addToCart(btn) {
    var d = prices();
    if (!d.v || !d.v.id) return;
    var trial = S.buyType === 'otp' && CFG.trial && CFG.trialCode;
    var main = { id: d.v.id, quantity: S.buyType === 'otp' ? d.otpPacks : d.P.packs, properties: {} };
    if (S.plan) main.properties._dog_name = S.plan.name;
    if (S.buyType === 'sub' && d.plan) main.selling_plan = d.plan.id;
    var items = [main];
    $$('[data-gjf-addon]').forEach(function (b) {
      var vid = +b.getAttribute('data-gjf-addon');
      if (!S.addons[vid]) return;
      var it = { id: vid, quantity: 1 };
      if (S.buyType === 'sub') it.selling_plan = CFG.addonPlan; // chews ship every 4 weeks
      items.push(it);
    });
    var orig = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    // Same as FDR: the trial code goes on the cart BEFORE the add, so the drawer's first paint already shows the trial price.
    replacePlan('joy-meal', main.properties._dog_name)
      .then(function () { return trial ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: CFG.trialCode }) }).catch(function () {}) : null; })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); }); return r.json(); })
      .then(function () {
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'gjf_add_to_cart', recipe: S.recipe, weight: S.weight, mode: S.mode, packs: d.P.packs, type: S.buyType, weeks: S.buyType === 'sub' ? d.P.wk : 0, total: d.total / 100 }); } catch (e) {}
        var after = function () { btn.disabled = false; btn.textContent = '✓ Added to cart'; setTimeout(function () { btn.innerHTML = orig; render(); }, 3000); openCart(); };
        // Belt and braces (as FDR): also set the classic discount cookie so checkout carries the code.
        if (trial) fetch('/discount/' + encodeURIComponent(CFG.trialCode), { credentials: 'same-origin' }).then(after, after); else after();
      })
      .catch(function (err) {
        btn.disabled = false; btn.innerHTML = orig; render();
        var el = $('[data-gjf=cart-error]'); if (el) { el.textContent = err.message || 'Something went wrong — please try again.'; el.hidden = false; setTimeout(function () { el.hidden = true; }, 5000); }
      });
  }

  /* ---------- sticky bar ---------- */
  var bb = $('[data-gjf-buybox]'), close = $('.gjc-close'), raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var past = bb && bb.getBoundingClientRect().bottom < 0;
      var cr = close && close.getBoundingClientRect();
      var atClose = cr && cr.top < window.innerHeight && cr.bottom > 0;
      var stick = !!past && !atClose;
      if (stick !== S.sticky) { S.sticky = stick; var st = $('[data-gjf=sticky]'); if (st) st.hidden = !stick; }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // test hook for QA scripts (read-only)
  window.__gjf = { calc: calc, prices: prices, state: S, render: render };

  renderPlan();
  render();
  onScroll();
})();

/* R49 · swipe the product gallery on touch (taps the matching arrow) */
(function () {
  if (window.__gjSwipe) return; window.__gjSwipe = 1;
  document.addEventListener('touchstart', function (e) {
    var s = e.target.closest && e.target.closest('.gjc-gal-stage,.gjx-gal-frame');
    if (!s || e.touches.length > 1) return;
    var x0 = e.touches[0].clientX, y0 = e.touches[0].clientY;
    function end(ev) {
      s.removeEventListener('touchend', end);
      var t = ev.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var b = s.querySelector(dx < 0 ? '[class*="gal-arrow--next"]' : '[class*="gal-arrow--prev"]');
        if (b) b.click();
      }
    }
    s.addEventListener('touchend', end, { passive: true });
  }, { passive: true });
})();
